import { motion } from "framer-motion"
import {
  IdCard,
  BookOpen,
  GraduationCap,
  FileText,
  Mail,
  Briefcase,
  CheckCircle2
} from "lucide-react"
import "./Admissions.css"

const Admissions = ({ countryData }) => {
  const requirements = countryData?.admissionRequirements || []

  const icons = [
    IdCard,
    BookOpen,
    GraduationCap,
    FileText,
    Mail,
    Briefcase,
  ]

  return (
    <div className="admissions-container">
      <motion.h1
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        Admission Requirements for {countryData?.name}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        viewport={{ once: true }}
        className="requirements-intro"
      >
        Your roadmap to a successful application. Ensure you have the following documents ready for your journey.
      </motion.p>

      <div className="requirements-grid">
        {requirements.map((req, idx) => {
          const Icon = icons[idx % icons.length]
          return (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              viewport={{ once: true }}
              className="requirement-item"
            >
              <div className="requirement-icon">
                <Icon size={24} />
              </div>
              <div className="requirement-text">{req}</div>
              <CheckCircle2 size={18} color="#06b6d4" style={{ marginLeft: 'auto', opacity: 0.5 }} />
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}

export default Admissions
